<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="shipmentDetail">
    <a-layout>
      <a-layout-header style="background: rgba(0,0,0,0.01); padding: 0">
        <div class="detail-operations">
          <a-button icon="left" @click="backToMain()">Kembali</a-button>
          <span class="detail-title">Rincian Pengiriman</span>
        </div>
      </a-layout-header>
      <a-layout-content class="detail-content" style="background: #fff;">
        <div v-if="loading" class="timeline-loading">
          <a-spin size="large"/>
        </div>
        <div v-else>
          <a-collapse v-if="shipments.length > 0" accordion>
            <a-collapse-panel
              v-for="(k, index) in shipments"
              :key="k.vAWBNumber"
              :header="'STTB No. '+k.vAWBNumber"
            >
              <shipment-tracking :shipment="k"/>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
import router from "../../router";
import ShipmentService from "@/services/ShipmentService";
import ShipmentTracking from "@/components/shipment/ShipmentTracking.vue";
import qs from "qs";

export default {
  components: {
    ShipmentTracking
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: true,
      shipments: []
    };
  },
  methods: {
    backToMain() {
      router.push("/myshipment/index");
      this.$emit("closePanel");
    },
    fetch() {
      const vthis = this;
      // eslint-disable-next-line no-console
      const objIds = qs.parse(this.$route.query.ids);

      var paramsId = "";

      for (const key in objIds) {
        if (objIds.hasOwnProperty(key)) {
          const element = objIds[key];
          // eslint-disable-next-line no-console

          if (paramsId == "") {
            paramsId += "(vAWBNumber = " + element + ")";
          } else {
            paramsId += " OR (vAWBNumber = " + element + ")";
          }
        }
      }

      var params = {
        filter: paramsId,
        include_count: true,
        order: "dPickupDate DESC"
      };

      this.loading = true;

      ShipmentService.getShipmentById(
        params,
        function(data) {
          const results = data.data;
          vthis.shipments = results.resource;
          vthis.loading = false;
        },
        function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
          vthis.loading = false;
        }
      );
    }
  }
};
</script>
    
<style>
.detail-operations > button,
.detail-operations > .ant-select {
  margin-left: 8px;
  margin-right: 8px;
}

.detail-title {
  font-size: 16px;
  font-weight: 600;
}

.detail-content {
  padding: 20px 0 20px 0;
  min-height: 200px;
}

.timeline-loading {
  min-height: 100px;
  text-align: center;
}
</style>